import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../services';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import { CSVLink } from "react-csv";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { AdvancedStatusReportSchema } from "../AdvancedRequestStatusReportSchema";
import { TableContentWithoutEdit } from '../../../Common/Table/tableContent';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';

const screenCode = 'ADVANCEDREQUESTSTATUSREPORT'

export function AdvancedRequestStatusReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [collectionCategory, setCollectionCategory] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionPointID: "0",
        toDate: "",
        fromDate: "",
        status: "",
        regNo: ""
    });
    console.log(searchData)


    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        operationEntity: "0",
        collectionPointID: "",
        toDate: "",
        fromDate: "",
        status: "",
        regNo: ""
    })

    const pdfRef = React.createRef();
    const [errors, setErrors] = useState({});

    const options = {
        orientation: 'landscape',
        unit: 'in',
        format: [1100, 700],

    };

    const schema = Joi.object(AdvancedStatusReportSchema).options({ allowUnknown: true });
    const contentRowNames = ["date", "collectionPointID", "regNo", "customerName", "requestedAmount", "approvedAmount", "status"]
    const csvHeaders = [
        { label: "Date", value: "date" },
        { label: "Collection Point", value: "collectionPointID" },
        { label: "Reg No", value: "regNo" },
        { label: "Customer Name", value: "customerName" },
        { label: "Requested Amount", value: "requestedAmount" },
        { label: "Approved Amount", value: "approvedAmount" },
        { label: "Status", value: "status" },
    ];

    const [data, setdata] = useState([]);

    const [csvData, setCsvData] = useState([]);

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [searchButtonHide, setSearchButtonHide] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);

    useEffect(() => {
        createDataTable();
        trackPromise(
            getPermissions()
        );
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionPointsForDropDown()
        );
    }, [searchData.operationEntityID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWADVANCEDREQUESTSTATUSREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        trackPromise(
            getGroupsForDropDown()
        );
    }

    function destroyDataTable() {
        $('#advancedRequestStatusReport').DataTable().destroy();
    }

    function createDataTable() {
        $('#advancedRequestStatusReport').DataTable();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }


    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, AdvancedStatusReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        })
    }

    async function handleSearch(e) {
        e.preventDefault();

        setIsTableHide(true);

        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

      
        const result = await service.getAdvancedRequestStatusReport(searchData.operationEntityID,
            searchData.collectionPointID, searchData.toDate, searchData.fromDate, searchData.regNo, searchData.status);

            result.forEach(x => {
                x.date = x.date.split('T')[0];

                if(x.status === 1){
                    x.status = "New";
                }
                else if(x.status === 2){
                    x.status = "Approved"
                }
                else if(x.status === 3){
                    x.status = "Rejected"
                }
                else if(x.status === 4){
                    x.status = "Delivered"
                }

                

                

            })
       
         destroyDataTable();
         setdata(result);
         setIsTableHide(false);
         createDataTable();
         setButtonHide(false);
         const comleteData = [...result];
      



        setCsvData(comleteData);
    }

    function createFile() {
        var settings = {
            sheetName: 'Advanced Request Status Report',
            fileName: 'AdvancedRequestStatusReport',
            writeOptions: {}
        }
        xlsx(csvHeaders, csvData, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            operationEntity: operationEntity[searchForm.operationEntityID],
            collectionPointID: collectionPoint[searchForm.collectionPointID],
            toDate: searchForm.toDate,
            fromDate: searchForm.fromDate,
            status: searchForm.status,
            regNo: searchForm.regNo
        })
    }


    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function hideSearchButton() {

        setSearchButtonHide(true);
    }

    function showSearchButton() {

        setSearchButtonHide(false);
    }
    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div ref={pdfRef} className="card-body">
                        <div className="row">
                            <PageHeader
                                title="Advanced Request Status Report"
                                isButtonEnable={false}
                            />
                        </div>
                        <form >
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        name="groupID"
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        name="operationEntityID"
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID *">Collection point</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Collection point--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <TextField
                                        id="fromDate"
                                        label="From Date *"
                                        name="fromDate"
                                        type="date"
                                        fullWidth
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>

                                <div className="col-md pb-1">
                                    <TextField
                                        id="toDate"
                                        label="To Date *"
                                        name="toDate"
                                        type="date"
                                        fullWidth
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className="col-md">
                                    <TextField select fullWidth
                                        label="Status "
                                        id="status"
                                        name="status"
                                        value={searchData.status}
                                        type="text"
                                        onChange={(e) => handleChange(e)}>
                                        <option value="0">--Select Status--</option>
                                        <option value="1">New</option>
                                        <option value="2">Approved</option>
                                        <option value="3">Rejected</option>
                                        <option value="4">Delivered</option>
                                    </TextField>
                                </div>

                                <div className="col-md-4">
                                    <InputLabel shrink id="qtyFrom">RegNo</InputLabel>
                                    <TextField
                                        fullWidth
                                        id="regNo"
                                        name="regNo"
                                        type="text"
                                        value={searchData.regNo}
                                        onChange={(e) => handleChange(e)}

                                    />
                                    {errors["regNo"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["regNo"]}</FormHelperText>)}
                                </div>


                            </div>

                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        disabled={validate(schema, searchData)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                        hidden={searchButtonHide}
                                    />
                                </div>
                            </div>
                        </form>

                        {isTableHide ? null :
                            <div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-responsive row-top-gap">
                                            <table id="adavancedRequestStatusReport" className="display dataTable no-footer">
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Collection Point</th>
                                                        <th>RegNo</th>
                                                        <th>Customer Name</th>
                                                        <th>Requested Amount</th>
                                                        <th>Approved Amount</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <TableContentWithoutEdit
                                                        data={data}
                                                        contentRowNames={contentRowNames}
                                                    />
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div className="pt-2">
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                    <ReactToPrint
                                        documentTitle={"Daily Collection Summary Report"}
                                        trigger={() => <input
                                            type="submit"
                                            className="btn btn-primary pull-right ml-2"
                                            value="PDF"

                                        />}
                                        content={() => componentRef.current}
                                    />
                                </div>
                                <div hidden={true}>
                                    <CreatePdf ref={componentRef} data={data}
                                        rowNames={contentRowNames} searchData={selectedSearchValues} />

                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    );
}



